// React
import React, { Component } from "react";

// Components
import { CandleStickChart, ChartMenu, ChartDetails, MobileDetails } from './';
import { Loader } from '../../Components';

// Stores
import { ChartStore } from '../../Stores';

// Styles
import "./charts.css";

class Chart extends Component {

/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            chartData : [],
            values : [],
            start: null,
            end: null,

            // Window dimensions
            width: window.innerWidth,
            height: window.innerHeight,

            // Chart Properties
            chartProperties: {},

            // Chart Type
            chartType : 'Candlestick',

            // Overlays
            overlays : [],

            topic: null,

            fav : 'icon-heart6 text-pink icon-button',

            loading: true

        };

        // bindings
        this.refreshChart = this.refreshChart.bind(this);

    }


/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render, fetch all chart parameters, chart settings, last or default chart and currency list
    componentDidMount() {

        //console.log('Chart.componentDidMount()');

        // Check screen size
        var screenSize = this.updateScreenSize();

        // Chart Parameters
        var params = ChartStore.getAllParameters();
        var topic = params.currency + '-' + params.exchange + '-' + params.quoteCurrency;

        // Retrieve last chart with 70 candles on display
        var data = ChartStore.getChart(this.props.properties.candlesAppearance.number);
        var chartExpired = ChartStore.isChartExpired();

        // If chart data exists, fetch currencies and add to state
        if(data === null || chartExpired) {

            // fetch chart
            this.getChart()
                .then( (data) => {

                    //this.startLiveUpdating();

                    this.setState((prev, props) => {
                        return {
                            chartData : data.chart,
                            start : data.start,
                            end : data.end,
                            width : screenSize.width,
                            height: screenSize.height,
                            topic : topic,
                            loading : false
                        }
                    });

                })
                .catch( (error) => {

                    // error with chart
                });
        }
        else {
            
            //this.startLiveUpdating();
            this.setState((prev, props) => {
                return {
                    chartData : data.chart,
                    start : data.start,
                    end : data.end,
                    width : screenSize.width,
                    height : screenSize.height,
                    topic : topic,
                    loading : false
                }
            });
        }

    }


    // Gets the latest screen size
    updateScreenSize() {
        return { width: window.innerWidth, height: window.innerHeight };
    }


    // Retrieve the chart and return as promise
    getChart() {

        //console.log('Chart.getChart()');

        return new Promise( (resolve, reject) => {

            // Retrieve the chart with 70 visibile candles
            ChartStore.fetchChart(this.props.properties.candlesAppearance.number)
                .then( (response) => {

                    resolve(response);

                })
                .catch( (error) => {

                    reject(error);

                });
        });

    }


/**********************************************************
 *  Chart Menu Functions
 **********************************************************/

    // Refresh the chart
    refreshChart() {

        //console.log('Chart.refreshChart()');

        this.setState({ loading : true });

        // fetch chart
        this.getChart()
            .then( (data) => {

                var screenSize = this.updateScreenSize();

                this.setState((prev, props) => {
                    return {
                        chartData : data.chart.chart,
                        width : screenSize.width,
                        height : screenSize.height,
                        loading : false
                    }
                });

            })
            .catch( (error) => {

                // error with chart
            });
    }


    // Favourites a chart
    favouriteChart() {
        
        //console.log('Charts.favouriteChart()');

        var newClass = '';

        if(this.state.fav === 'icon-heart5 text-pink icon-button')
            newClass = 'icon-heart6 text-pink icon-button';
        else
            newClass = 'icon-heart5 text-pink icon-button';
        
        this.setState((prev, props) => {
            return {
                fav : newClass
            }
        });

    }

    // Given newly selected chart parameters, save in chart store and retrieve new chart
    selectedParameters(params) {

        //console.log('Charts.selectedParameters()');

        this.setState({ loading : true });

        ChartStore.setAllParameters(params.currency, params.exchange, params.quoteCurrency, params.interval);

        this.getChart()
            .then( (response) => {

                this.setState((prev, props) => {
                    return {
                        chartData : response.chart,
                        start : response.start,
                        end : response.end,
                        topic : params.currency + '-' + params.exchange + '-' + params.quoteCurrency,
                        loading : false
                    }
                });

            })
            .catch( (error) => {
                console.log('ERROR: Charts.selectedParameters(): ' + error.message);
            });

    }

    // Change the chart type between Candlestick and Heikin Ashii
    selectChartType(type) {

        this.setState((prev, props) => {
            return {
                chartType : type
            }
        });
    }

    // Given an overlay, either add or remove it from chart
    selectOverlay(overlay, add) {

        var overlays = this.state.overlays;

        // Add or remove
        if(add)
            overlays.push(overlay);
        else
            overlays.splice(overlays.indexOf(overlay), 1);

        this.setState((prev, props) => {
            return {
                overlays : overlays
            }
        });

    }



/**********************************************************
 *  Live Updating Functions
 **********************************************************/

    startLiveUpdating() {

        var params = ChartStore.getAllParameters();

        var interval = null;
        if(params.interval === 'minute')
            interval = 60 * 1000; // 1 minute
        else if(params.interval === 'hour')
            interval = 5 * 60 * 1000; // 5 minute
        else {
            interval = 120 * 60 * 1000; // 120 minutes
        }

        setInterval(this.refreshChart, interval);
    }


/**********************************************************
 *  Render
 **********************************************************/

  render() {

    //console.log('Chart.render()');

    var chart = (<div className='placeholder'><Loader /></div>);

    // Only build chart if there is data
    if(this.state.chartData.length > 0 && !this.state.loading) {
        
        chart = (<CandleStickChart data={this.state.chartData} from={this.state.start} to={this.state.end} 
        properties={this.props.properties} chartType={this.state.chartType} overlays={this.state.overlays}></CandleStickChart>);
    }

    var details = null;
    var mobileDetails = null;

    // Only pass topic to chart details if it exists
    if(this.state.topic !== null) {

        if(this.props.mobile)
            mobileDetails = (<MobileDetails topic={this.state.topic} mobile={this.props.mobile} refreshChart={this.refreshChart} 
                onSelectChartType={this.selectChartType.bind(this)} onSelectOverlay={this.selectOverlay.bind(this)}/>);
        else
            details = (<ChartDetails topic={this.state.topic} mobile={this.props.mobile} refreshChart={this.refreshChart} />);
    }

    return (

        <div className="chart-container">

            {/*-----------  Dropdown Menu -----------*/}
            <div className="row" id="chart-menu-row">

                 <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    {mobileDetails}
                </div>

                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                    <ChartMenu onSelectParameters={this.selectedParameters.bind(this)} refreshChart={this.refreshChart} 
                    onSelectChartType={this.selectChartType.bind(this)} onSelectOverlay={this.selectOverlay.bind(this)} mobile={this.props.mobile}/>
                </div>

            </div>
            {/*----------- End Dropdown Menu -----------*/}
                        
            
            {/*----------- Chart Area -----------*/}
            <div className="row" id="chart-row">

                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12" id="chart"> 
                    {chart}
                </div>

                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12" id="chart-details" style={{padding:0,paddingLeft:'5px'}}>
                    {details}
                </div>

            </div>
            {/*----------- End Chart Area -----------*/}

        </div>

    );
  }
}

export default Chart;





// WEBPACK FOOTER //
// ./src/Views/Charting/Chart.js